import React from 'react';
import { TeamPermission } from 'nekst-api';
import WebhookSubscriptionsList from './WebhookSubscriptionsList';
import AccessChecker from '../../../shared/authorization/AccessChecker';
import { SettingsBreadcrumbs } from '../../settingsModule';
import { Breadcrumb } from '../../../shared/web/layout/Breadcrumbs';

export default function WebhookSubscriptionsPage() {
  return (
    <AccessChecker permissionToCheck={TeamPermission.MANAGE_INTEGRATIONS}>
      <SettingsBreadcrumbs>
        <Breadcrumb text="Webhook Subscriptions" />
      </SettingsBreadcrumbs>
      <WebhookSubscriptionsList />
    </AccessChecker>
  );
}
